import { TPieChartItem } from '@/components/PieChart/components/PieChartExtended.types';

export const generateAssetValuePercent = (
  count: number,
  nav: number,
  total: number
): number => {
  const price = count * nav;
  const percent = (price / total) * 100;
  const fixedPercent = parseFloat(percent.toFixed(1));
  return fixedPercent;
};

export const sortPieChartItems = (items: TPieChartItem[]): TPieChartItem[] => {
  return items.sort((a, b) => {
    if (a.value > b.value) {
      return -1;
    }
    if (a.value < b.value) {
      return 1;
    }
    return 0;
  });
};
